export function formatNumberWithCommas(num: number): string {
  if (num <= 0) {
    return "";
  }
  return new Intl.NumberFormat("en-US").format(num);
}

export function parseFormattedNumber(value: string): number {
  const cleanValue = value.replace(/,/g, "");
  return parseInt(cleanValue) || 0;
}
